<template>
    <div class="d-flex bg-light rounded border m-1 p-1" :class="activeClasses" :style="activeStyles"
         @mouseover="displayDelete = true" @mouseout="displayDelete = false" @click="onTabClick">
        <div class="me-auto">
            {{tab.label}}
        </div>

        <div><i class="fa fa-times pointer text-secondary" @click="onRemoveTabClick()"
                @mouseover="displayDelete = true"></i></div>
    </div>

</template>

<script>
    export default {
        name: 'TabDisplay',
        props: ['tab', 'index', 'currentView'],
        computed: {
            isCurrentView() {
                return this.currentView.id === this.tab.resource
            },
            activeStyles() {
                return this.isCurrentView ? 'background-color: #bac7f8 !important;' : ''
            },
            activeClasses() {
                return this.isCurrentView ? '' : 'pointer'
            }
        },
        data() {
            return {
                model: webase.model,
                displayDelete: false
            }
        },
        mounted() {
        },
        methods: {
            onRemoveTabClick() {
                this.$emit('removeTabClick', this.index)
            },
            onTabClick() {
                if(!this.isCurrentView) {
                    this.$router.push({ name: 'view-renderer', params: {id: this.tab.resource}})
                }
            }
        }
    }
</script>

<style>

</style>
